import { useState, useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { message } from 'antd';
import { FeatureFlags } from './feature-flags';
import { BlobFeatureFlag, StaffFeatureFlagsContainerBlobFeatureFlagsDocument, StaffFeatureFlagsContainerUpdateBlobFeatureFlagsDocument } from '../../../../generated';

export const FeatureFlagContainer = () => {
  const [featureFlag, setFeatureFlag] =  useState<BlobFeatureFlag[]>([]);
  const { data: featureFlagData,
    loading: featureFlagLoading,
    error: featureFlagError,
  } = useQuery(StaffFeatureFlagsContainerBlobFeatureFlagsDocument,  {
    fetchPolicy: 'network-only',
  });


useEffect(() => {
      setFeatureFlag(featureFlagData?.blobFeatureFlags as BlobFeatureFlag[]); ;
  } , [featureFlagData]);

  const [blobFeatureFlagsUpdate, { loading: updateLoading }] = useMutation(StaffFeatureFlagsContainerUpdateBlobFeatureFlagsDocument, {
    refetchQueries: [
      {
        query: StaffFeatureFlagsContainerBlobFeatureFlagsDocument,
        variables: {
          blobData: {
            featureFlags: []
          }
        }
      },
    ],
    awaitRefetchQueries: true,
  });

  const handleSave = async (data: any) => {
    const updatedArray = data.map(({ __typename, ...rest }: { __typename: any, [key: string]: any }) => rest);
    try {
      await blobFeatureFlagsUpdate({
        variables: {
            input: {
              blobData: {
                featureFlags: updatedArray
              }
          }
        },
      });
      message.success('Feature Flags details updated');
    } catch (error) {
      message.error(`Error Updating Feature Flags : ${JSON.stringify(error)}`);
    }
  };

  return (
    <ComponentQueryLoader
      hasData={featureFlag !== undefined}
      error={featureFlagError}
      loading={featureFlagLoading || updateLoading}
      hasDataComponent={
      <FeatureFlags
        featureFlags={featureFlag}
        onSave={handleSave}
      />
      }
    />
  );
};
